const isUuid = (value) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(value));

export const inferZoomMeetingIdFromJoinUrl = (joinUrl) => {
  if (!joinUrl) return null;
  const match = String(joinUrl).match(/\/j\/(\d+)/);
  return match ? match[1] : null;
};

export const resolveExternalMeetingId = (meeting, providerKey) => {
  if (!meeting || typeof meeting !== 'object') return null;

  if (providerKey === 'zoom') {
    const zoomMeetingId = meeting.zoomMeetingId ?? meeting.ZoomMeetingId;
    if (zoomMeetingId != null && zoomMeetingId !== '') {
      return String(zoomMeetingId);
    }
  }

  const meetingId = meeting.meetingId
    ?? meeting.MeetingId
    ?? meeting.zoomMeetingId
    ?? meeting.ZoomMeetingId
    ?? meeting.id
    ?? meeting.Id;

  return meetingId != null && meetingId !== '' ? String(meetingId) : null;
};

export const normalizeExternalMeetingId = (externalMeetingId, providerKey, joinUrl) => {
  if (externalMeetingId == null || externalMeetingId === '') return null;

  const normalized = String(externalMeetingId);
  if (providerKey === 'zoom' && isUuid(normalized)) {
    return inferZoomMeetingIdFromJoinUrl(joinUrl) || normalized;
  }

  return normalized;
};

export const resolveEventExternalMeetingId = (event) => {
  const meeting = event?.resource?.meeting || {};
  const providerKey = event?.resource?.provider
    || (String(meeting.meetingProvider || '').toLowerCase().includes('zoom') ? 'zoom' : null)
    || (String(meeting.meetingProvider || '').toLowerCase().includes('google') ? 'google' : null);

  const storedId = event?.resource?.externalMeetingId
    ?? meeting.externalMeetingId
    ?? meeting.ExternalMeetingId
    ?? null;

  if (storedId != null && storedId !== '') {
    const normalized = String(storedId);
    if (providerKey === 'zoom' && isUuid(normalized)) {
      const fromJoinUrl = inferZoomMeetingIdFromJoinUrl(event?.resource?.joinUrl);
      if (fromJoinUrl) return fromJoinUrl;
    }
    return normalized;
  }

  return null;
};
